//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function createVisit(createVisitDto: Types.CreateVisitDto, config?: AxiosRequestConfig | undefined): Promise<Types.VisitDto> {
    let url_ = getBaseUrl() + "/api/appointments/visits";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateVisitDto(createVisitDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateVisit,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateVisit?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateVisit(_response);
    });
}

function processCreateVisit(response: AxiosResponse): Promise<Types.VisitDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initVisitDto(resultData200);
        return Promise.resolve<Types.VisitDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initVisitDto(resultData201);
        return Promise.resolve<Types.VisitDto>(result201);

    } else if (status === 409) {
        const _responseText = response.data;
        let result409: any = null;
        let resultData409  = _responseText;
        result409 = Types.initProblemDetails(resultData409);
        return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.VisitDto>(null as any);
}

/**
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param subtenants (optional) 
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function searchVisits(patientId?: number | null | undefined, caseId?: number | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, subtenants?: number[] | null | undefined, isWaitingList?: boolean | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.VisitListDto[]> {
    let url_ = getBaseUrl() + "/api/appointments/visits?";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (caseId !== undefined && caseId !== null)
        url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
    if (importIds !== undefined && importIds !== null)
        importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (number !== undefined && number !== null)
        number && number.forEach(item => { url_ += "Number=" + encodeURIComponent("" + item) + "&"; });
    if (from !== undefined && from !== null)
        url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to !== undefined && to !== null)
        url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    if (subtenants !== undefined && subtenants !== null)
        subtenants && subtenants.forEach(item => { url_ += "Subtenants=" + encodeURIComponent("" + item) + "&"; });
    if (isWaitingList === null)
        throw new Error("The parameter 'isWaitingList' cannot be null.");
    else if (isWaitingList !== undefined)
        url_ += "IsWaitingList=" + encodeURIComponent("" + isWaitingList) + "&";
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (includeValues === null)
        throw new Error("The parameter 'includeValues' cannot be null.");
    else if (includeValues !== undefined)
        url_ += "IncludeValues=" + encodeURIComponent("" + includeValues) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearchVisits,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearchVisits?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearchVisits(_response);
    });
}

function processSearchVisits(response: AxiosResponse): Promise<Types.VisitListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initVisitListDto(item)
              );
            }
        return Promise.resolve<Types.VisitListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.VisitListDto[]>(null as any);
}

export function updateVisit(id: number, patchDto: Types.PatchVisitDto, config?: AxiosRequestConfig | undefined): Promise<Types.VisitDto> {
    let url_ = getBaseUrl() + "/api/appointments/visits/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchVisitDto(patchDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateVisit,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigUpdateVisit?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateVisit(_response);
    });
}

function processUpdateVisit(response: AxiosResponse): Promise<Types.VisitDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initVisitDto(resultData200);
        return Promise.resolve<Types.VisitDto>(result200);

    } else if (status === 409) {
        const _responseText = response.data;
        let result409: any = null;
        let resultData409  = _responseText;
        result409 = Types.initProblemDetails(resultData409);
        return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.VisitDto>(null as any);
}

export function getVisit(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.VisitDto> {
    let url_ = getBaseUrl() + "/api/appointments/visits/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetVisit,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetVisit?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetVisit(_response);
    });
}

function processGetVisit(response: AxiosResponse): Promise<Types.VisitDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initVisitDto(resultData200);
        return Promise.resolve<Types.VisitDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.VisitDto>(null as any);
}

export function deleteAppointment(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/appointments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteAppointment,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteAppointment?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteAppointment(_response);
    });
}

function processDeleteAppointment(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function searchAppointments(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AppointmentEventDto[]> {
    let url_ = getBaseUrl() + "/api/appointments?";
    if (id !== undefined && id !== null)
        url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (ids !== undefined && ids !== null)
        ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
    if (from !== undefined && from !== null)
        url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to !== undefined && to !== null)
        url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    if (eventTypes !== undefined && eventTypes !== null)
        eventTypes && eventTypes.forEach(item => { url_ += "EventTypes=" + encodeURIComponent("" + item) + "&"; });
    if (subtenants !== undefined && subtenants !== null)
        subtenants && subtenants.forEach(item => { url_ += "Subtenants=" + encodeURIComponent("" + item) + "&"; });
    if (tags !== undefined && tags !== null)
        tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
    if (visitTypes !== undefined && visitTypes !== null)
        visitTypes && visitTypes.forEach(item => { url_ += "VisitTypes=" + encodeURIComponent("" + item) + "&"; });
    if (patients !== undefined && patients !== null)
        patients && patients.forEach(item => { url_ += "Patients=" + encodeURIComponent("" + item) + "&"; });
    if (visitStatuses !== undefined && visitStatuses !== null)
        visitStatuses && visitStatuses.forEach(item => { url_ += "VisitStatuses=" + encodeURIComponent("" + item) + "&"; });
    if (resourceIds !== undefined && resourceIds !== null)
        resourceIds && resourceIds.forEach(item => { url_ += "ResourceIds=" + encodeURIComponent("" + item) + "&"; });
    if (placesIds !== undefined && placesIds !== null)
        placesIds && placesIds.forEach(item => { url_ += "PlacesIds=" + encodeURIComponent("" + item) + "&"; });
    if (specialConditionsIds !== undefined && specialConditionsIds !== null)
        specialConditionsIds && specialConditionsIds.forEach(item => { url_ += "SpecialConditionsIds=" + encodeURIComponent("" + item) + "&"; });
    if (doctorIds !== undefined && doctorIds !== null)
        doctorIds && doctorIds.forEach(item => { url_ += "DoctorIds=" + encodeURIComponent("" + item) + "&"; });
    if (isWithoutResources !== undefined && isWithoutResources !== null)
        url_ += "IsWithoutResources=" + encodeURIComponent("" + isWithoutResources) + "&";
    if (isWithoutCanceledVisits === null)
        throw new Error("The parameter 'isWithoutCanceledVisits' cannot be null.");
    else if (isWithoutCanceledVisits !== undefined)
        url_ += "IsWithoutCanceledVisits=" + encodeURIComponent("" + isWithoutCanceledVisits) + "&";
    if (isWaitingList === null)
        throw new Error("The parameter 'isWaitingList' cannot be null.");
    else if (isWaitingList !== undefined)
        url_ += "IsWaitingList=" + encodeURIComponent("" + isWaitingList) + "&";
    if (queries !== undefined && queries !== null)
        queries && queries.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "Queries[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearchAppointments,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearchAppointments?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearchAppointments(_response);
    });
}

function processSearchAppointments(response: AxiosResponse): Promise<Types.AppointmentEventDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initAppointmentEventDto(item)
              );
            }
        return Promise.resolve<Types.AppointmentEventDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AppointmentEventDto[]>(null as any);
}

/**
 * Search for appointments in all subtenants (even if they are unavailable to current user)
and return anonymized information about these appointments (start date, end date and occupied resources)
 * @param id (optional) 
 * @param ids (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param eventTypes (optional) 
 * @param subtenants (optional) 
 * @param tags (optional) 
 * @param visitTypes (optional) 
 * @param patients (optional) 
 * @param visitStatuses (optional) 
 * @param resourceIds (optional) At least one Resource must be present in the Appointment to pass the filter.
You could actually put PlacesIds, SpecialConditionsIds and DoctorIds in this field
and you will receive all visits that have at least one Resource out of them.
This is useful for ResourceView
 * @param placesIds (optional) At least one Place is needed to be present in the Appointment
 * @param specialConditionsIds (optional) At least one SpecialCondition is needed to be present in the Appointment
 * @param doctorIds (optional) At least one Doctor is needed to be present in the Appointment
 * @param isWithoutResources (optional) Includes/excludes visits without resources (makes sense only if ResourceIds is not empty)
 * @param isWithoutCanceledVisits (optional) If true, canceled visits are excluded
 * @param isWaitingList (optional) If true, only visits from waiting list are included
If false, visits from waiting list are excluded
 * @param queries (optional) Queries for additional data that should be returned from Backend so that Clients could calculate some custom Expressions
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function searchAppointmentsWithResourceOccupation(id?: number | null | undefined, ids?: number[] | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, eventTypes?: Types.AppointmentType[] | null | undefined, subtenants?: number[] | null | undefined, tags?: number[] | null | undefined, visitTypes?: number[] | null | undefined, patients?: number[] | null | undefined, visitStatuses?: Types.AppointmentStatusCodes[] | null | undefined, resourceIds?: number[] | null | undefined, placesIds?: number[] | null | undefined, specialConditionsIds?: number[] | null | undefined, doctorIds?: number[] | null | undefined, isWithoutResources?: boolean | null | undefined, isWithoutCanceledVisits?: boolean | undefined, isWaitingList?: boolean | undefined, queries?: Types.JsQuery[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AppointmentResourceOccupationDto[]> {
    let url_ = getBaseUrl() + "/api/appointments/resource-occupation?";
    if (id !== undefined && id !== null)
        url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (ids !== undefined && ids !== null)
        ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
    if (from !== undefined && from !== null)
        url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to !== undefined && to !== null)
        url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    if (eventTypes !== undefined && eventTypes !== null)
        eventTypes && eventTypes.forEach(item => { url_ += "EventTypes=" + encodeURIComponent("" + item) + "&"; });
    if (subtenants !== undefined && subtenants !== null)
        subtenants && subtenants.forEach(item => { url_ += "Subtenants=" + encodeURIComponent("" + item) + "&"; });
    if (tags !== undefined && tags !== null)
        tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
    if (visitTypes !== undefined && visitTypes !== null)
        visitTypes && visitTypes.forEach(item => { url_ += "VisitTypes=" + encodeURIComponent("" + item) + "&"; });
    if (patients !== undefined && patients !== null)
        patients && patients.forEach(item => { url_ += "Patients=" + encodeURIComponent("" + item) + "&"; });
    if (visitStatuses !== undefined && visitStatuses !== null)
        visitStatuses && visitStatuses.forEach(item => { url_ += "VisitStatuses=" + encodeURIComponent("" + item) + "&"; });
    if (resourceIds !== undefined && resourceIds !== null)
        resourceIds && resourceIds.forEach(item => { url_ += "ResourceIds=" + encodeURIComponent("" + item) + "&"; });
    if (placesIds !== undefined && placesIds !== null)
        placesIds && placesIds.forEach(item => { url_ += "PlacesIds=" + encodeURIComponent("" + item) + "&"; });
    if (specialConditionsIds !== undefined && specialConditionsIds !== null)
        specialConditionsIds && specialConditionsIds.forEach(item => { url_ += "SpecialConditionsIds=" + encodeURIComponent("" + item) + "&"; });
    if (doctorIds !== undefined && doctorIds !== null)
        doctorIds && doctorIds.forEach(item => { url_ += "DoctorIds=" + encodeURIComponent("" + item) + "&"; });
    if (isWithoutResources !== undefined && isWithoutResources !== null)
        url_ += "IsWithoutResources=" + encodeURIComponent("" + isWithoutResources) + "&";
    if (isWithoutCanceledVisits === null)
        throw new Error("The parameter 'isWithoutCanceledVisits' cannot be null.");
    else if (isWithoutCanceledVisits !== undefined)
        url_ += "IsWithoutCanceledVisits=" + encodeURIComponent("" + isWithoutCanceledVisits) + "&";
    if (isWaitingList === null)
        throw new Error("The parameter 'isWaitingList' cannot be null.");
    else if (isWaitingList !== undefined)
        url_ += "IsWaitingList=" + encodeURIComponent("" + isWaitingList) + "&";
    if (queries !== undefined && queries !== null)
        queries && queries.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "Queries[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearchAppointmentsWithResourceOccupation,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearchAppointmentsWithResourceOccupation?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearchAppointmentsWithResourceOccupation(_response);
    });
}

function processSearchAppointmentsWithResourceOccupation(response: AxiosResponse): Promise<Types.AppointmentResourceOccupationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initAppointmentResourceOccupationDto(item)
              );
            }
        return Promise.resolve<Types.AppointmentResourceOccupationDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AppointmentResourceOccupationDto[]>(null as any);
}

export function cancelVisit(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/appointments/visits/{id}/cancel";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCancelVisit,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigCancelVisit?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCancelVisit(_response);
    });
}

function processCancelVisit(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function confirmVisit(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/appointments/visits/{id}/confirm";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigConfirmVisit,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigConfirmVisit?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processConfirmVisit(_response);
    });
}

function processConfirmVisit(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function completeVisit(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/appointments/visits/{id}/complete";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCompleteVisit,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigCompleteVisit?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCompleteVisit(_response);
    });
}

function processCompleteVisit(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function createMeeting(createMeetingDto: Types.CreateMeetingDto, config?: AxiosRequestConfig | undefined): Promise<Types.MeetingDto> {
    let url_ = getBaseUrl() + "/api/appointments/meetings";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateMeetingDto(createMeetingDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateMeeting,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateMeeting?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateMeeting(_response);
    });
}

function processCreateMeeting(response: AxiosResponse): Promise<Types.MeetingDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMeetingDto(resultData200);
        return Promise.resolve<Types.MeetingDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initMeetingDto(resultData201);
        return Promise.resolve<Types.MeetingDto>(result201);

    } else if (status === 409) {
        const _responseText = response.data;
        let result409: any = null;
        let resultData409  = _responseText;
        result409 = Types.initProblemDetails(resultData409);
        return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MeetingDto>(null as any);
}

export function findFreeTimeSlot(patientId?: number | undefined, visitTypeId?: number | undefined, start?: Date | undefined, durationInSeconds?: number | undefined, timeStepInSeconds?: number | undefined, searchDirection?: Types.SearchDirection | undefined, skipCurrentDay?: boolean | undefined, isParticularTime?: boolean | undefined, searchIntervalForwardInDays?: number | undefined, searchIntervalBackwardInDays?: number | undefined, visitId?: number | null | undefined, resourceIds?: number[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FindFreeTimeSlotResultDto> {
    let url_ = getBaseUrl() + "/api/appointments/free-time-slot?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (visitTypeId === null)
        throw new Error("The parameter 'visitTypeId' cannot be null.");
    else if (visitTypeId !== undefined)
        url_ += "VisitTypeId=" + encodeURIComponent("" + visitTypeId) + "&";
    if (start === null)
        throw new Error("The parameter 'start' cannot be null.");
    else if (start !== undefined)
        url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
    if (durationInSeconds === null)
        throw new Error("The parameter 'durationInSeconds' cannot be null.");
    else if (durationInSeconds !== undefined)
        url_ += "DurationInSeconds=" + encodeURIComponent("" + durationInSeconds) + "&";
    if (timeStepInSeconds === null)
        throw new Error("The parameter 'timeStepInSeconds' cannot be null.");
    else if (timeStepInSeconds !== undefined)
        url_ += "TimeStepInSeconds=" + encodeURIComponent("" + timeStepInSeconds) + "&";
    if (searchDirection === null)
        throw new Error("The parameter 'searchDirection' cannot be null.");
    else if (searchDirection !== undefined)
        url_ += "SearchDirection=" + encodeURIComponent("" + searchDirection) + "&";
    if (skipCurrentDay === null)
        throw new Error("The parameter 'skipCurrentDay' cannot be null.");
    else if (skipCurrentDay !== undefined)
        url_ += "SkipCurrentDay=" + encodeURIComponent("" + skipCurrentDay) + "&";
    if (isParticularTime === null)
        throw new Error("The parameter 'isParticularTime' cannot be null.");
    else if (isParticularTime !== undefined)
        url_ += "IsParticularTime=" + encodeURIComponent("" + isParticularTime) + "&";
    if (searchIntervalForwardInDays === null)
        throw new Error("The parameter 'searchIntervalForwardInDays' cannot be null.");
    else if (searchIntervalForwardInDays !== undefined)
        url_ += "SearchIntervalForwardInDays=" + encodeURIComponent("" + searchIntervalForwardInDays) + "&";
    if (searchIntervalBackwardInDays === null)
        throw new Error("The parameter 'searchIntervalBackwardInDays' cannot be null.");
    else if (searchIntervalBackwardInDays !== undefined)
        url_ += "SearchIntervalBackwardInDays=" + encodeURIComponent("" + searchIntervalBackwardInDays) + "&";
    if (visitId !== undefined && visitId !== null)
        url_ += "VisitId=" + encodeURIComponent("" + visitId) + "&";
    if (resourceIds !== undefined && resourceIds !== null)
        resourceIds && resourceIds.forEach(item => { url_ += "ResourceIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigFindFreeTimeSlot,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigFindFreeTimeSlot?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processFindFreeTimeSlot(_response);
    });
}

function processFindFreeTimeSlot(response: AxiosResponse): Promise<Types.FindFreeTimeSlotResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initFindFreeTimeSlotResultDto(resultData200);
        return Promise.resolve<Types.FindFreeTimeSlotResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FindFreeTimeSlotResultDto>(null as any);
}

export function getAbsence(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.AbsenceDto> {
    let url_ = getBaseUrl() + "/api/appointments/absences/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAbsence,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetAbsence?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAbsence(_response);
    });
}

function processGetAbsence(response: AxiosResponse): Promise<Types.AbsenceDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initAbsenceDto(resultData200);
        return Promise.resolve<Types.AbsenceDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AbsenceDto>(null as any);
}

export function patchAbsence(id: number, patchDto: Types.PatchAbsenceDto, config?: AxiosRequestConfig | undefined): Promise<Types.AbsenceDto> {
    let url_ = getBaseUrl() + "/api/appointments/absences/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchAbsenceDto(patchDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchAbsence,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchAbsence?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchAbsence(_response);
    });
}

function processPatchAbsence(response: AxiosResponse): Promise<Types.AbsenceDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initAbsenceDto(resultData200);
        return Promise.resolve<Types.AbsenceDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AbsenceDto>(null as any);
}

export function createAbsence(createAbsenceDto: Types.CreateAbsenceDto, config?: AxiosRequestConfig | undefined): Promise<Types.AbsenceDto> {
    let url_ = getBaseUrl() + "/api/appointments/absences";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateAbsenceDto(createAbsenceDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateAbsence,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateAbsence?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateAbsence(_response);
    });
}

function processCreateAbsence(response: AxiosResponse): Promise<Types.AbsenceDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initAbsenceDto(resultData200);
        return Promise.resolve<Types.AbsenceDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initAbsenceDto(resultData201);
        return Promise.resolve<Types.AbsenceDto>(result201);

    } else if (status === 409) {
        const _responseText = response.data;
        let result409: any = null;
        let resultData409  = _responseText;
        result409 = Types.initProblemDetails(resultData409);
        return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AbsenceDto>(null as any);
}
let _requestConfigCreateVisit: Partial<AxiosRequestConfig> | null;
export function getCreateVisitRequestConfig() {
  return _requestConfigCreateVisit;
}
export function setCreateVisitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateVisit = value;
}
export function patchCreateVisitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateVisit = patch(_requestConfigCreateVisit ?? {});
}

let _requestConfigSearchVisits: Partial<AxiosRequestConfig> | null;
export function getSearchVisitsRequestConfig() {
  return _requestConfigSearchVisits;
}
export function setSearchVisitsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearchVisits = value;
}
export function patchSearchVisitsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearchVisits = patch(_requestConfigSearchVisits ?? {});
}

let _requestConfigUpdateVisit: Partial<AxiosRequestConfig> | null;
export function getUpdateVisitRequestConfig() {
  return _requestConfigUpdateVisit;
}
export function setUpdateVisitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateVisit = value;
}
export function patchUpdateVisitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateVisit = patch(_requestConfigUpdateVisit ?? {});
}

let _requestConfigGetVisit: Partial<AxiosRequestConfig> | null;
export function getGetVisitRequestConfig() {
  return _requestConfigGetVisit;
}
export function setGetVisitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetVisit = value;
}
export function patchGetVisitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetVisit = patch(_requestConfigGetVisit ?? {});
}

let _requestConfigDeleteAppointment: Partial<AxiosRequestConfig> | null;
export function getDeleteAppointmentRequestConfig() {
  return _requestConfigDeleteAppointment;
}
export function setDeleteAppointmentRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteAppointment = value;
}
export function patchDeleteAppointmentRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteAppointment = patch(_requestConfigDeleteAppointment ?? {});
}

let _requestConfigSearchAppointments: Partial<AxiosRequestConfig> | null;
export function getSearchAppointmentsRequestConfig() {
  return _requestConfigSearchAppointments;
}
export function setSearchAppointmentsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearchAppointments = value;
}
export function patchSearchAppointmentsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearchAppointments = patch(_requestConfigSearchAppointments ?? {});
}

let _requestConfigSearchAppointmentsWithResourceOccupation: Partial<AxiosRequestConfig> | null;
export function getSearchAppointmentsWithResourceOccupationRequestConfig() {
  return _requestConfigSearchAppointmentsWithResourceOccupation;
}
export function setSearchAppointmentsWithResourceOccupationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearchAppointmentsWithResourceOccupation = value;
}
export function patchSearchAppointmentsWithResourceOccupationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearchAppointmentsWithResourceOccupation = patch(_requestConfigSearchAppointmentsWithResourceOccupation ?? {});
}

let _requestConfigCancelVisit: Partial<AxiosRequestConfig> | null;
export function getCancelVisitRequestConfig() {
  return _requestConfigCancelVisit;
}
export function setCancelVisitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCancelVisit = value;
}
export function patchCancelVisitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCancelVisit = patch(_requestConfigCancelVisit ?? {});
}

let _requestConfigConfirmVisit: Partial<AxiosRequestConfig> | null;
export function getConfirmVisitRequestConfig() {
  return _requestConfigConfirmVisit;
}
export function setConfirmVisitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigConfirmVisit = value;
}
export function patchConfirmVisitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigConfirmVisit = patch(_requestConfigConfirmVisit ?? {});
}

let _requestConfigCompleteVisit: Partial<AxiosRequestConfig> | null;
export function getCompleteVisitRequestConfig() {
  return _requestConfigCompleteVisit;
}
export function setCompleteVisitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCompleteVisit = value;
}
export function patchCompleteVisitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCompleteVisit = patch(_requestConfigCompleteVisit ?? {});
}

let _requestConfigCreateMeeting: Partial<AxiosRequestConfig> | null;
export function getCreateMeetingRequestConfig() {
  return _requestConfigCreateMeeting;
}
export function setCreateMeetingRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateMeeting = value;
}
export function patchCreateMeetingRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateMeeting = patch(_requestConfigCreateMeeting ?? {});
}

let _requestConfigFindFreeTimeSlot: Partial<AxiosRequestConfig> | null;
export function getFindFreeTimeSlotRequestConfig() {
  return _requestConfigFindFreeTimeSlot;
}
export function setFindFreeTimeSlotRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigFindFreeTimeSlot = value;
}
export function patchFindFreeTimeSlotRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigFindFreeTimeSlot = patch(_requestConfigFindFreeTimeSlot ?? {});
}

let _requestConfigGetAbsence: Partial<AxiosRequestConfig> | null;
export function getGetAbsenceRequestConfig() {
  return _requestConfigGetAbsence;
}
export function setGetAbsenceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAbsence = value;
}
export function patchGetAbsenceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAbsence = patch(_requestConfigGetAbsence ?? {});
}

let _requestConfigPatchAbsence: Partial<AxiosRequestConfig> | null;
export function getPatchAbsenceRequestConfig() {
  return _requestConfigPatchAbsence;
}
export function setPatchAbsenceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchAbsence = value;
}
export function patchPatchAbsenceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchAbsence = patch(_requestConfigPatchAbsence ?? {});
}

let _requestConfigCreateAbsence: Partial<AxiosRequestConfig> | null;
export function getCreateAbsenceRequestConfig() {
  return _requestConfigCreateAbsence;
}
export function setCreateAbsenceRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateAbsence = value;
}
export function patchCreateAbsenceRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateAbsence = patch(_requestConfigCreateAbsence ?? {});
}